
<div class="experiment-dialog-header">
    <mat-toolbar id="dialog-titlebar" color="primary">
        <div>{{ data.isEditMode ? 'Edit' : 'Create' }} Experiment</div>
    </mat-toolbar>
</div>

<form [formGroup]="experimentForm" class="normal-form" (ngSubmit)="onSubmit()">
    <div mat-dialog-content class="experiment-dialog-content">
        <div class="experiment-controls-group">
            <p-floatlabel class="p-default-form-field p-float-label bottom-border-only">
                <input pInputText id="name" type="text" aria-describedby="name-error" formControlName="name" />
                <label for="name">Name</label>
                <small id="name-error" class="p-error" *ngIf="experimentForm.controls.name.errors?.required">
                    This field is mandatory.
                </small>
            </p-floatlabel>
            <p-floatlabel class="p-default-form-field p-float-label bottom-border-only">
                <textarea pInputText id="description" aria-describedby="description-error" formControlName="description" rows="5"></textarea>
                <label for="description">Description</label>
                <small id="description-error" class="p-error" *ngIf="experimentForm.controls.description.errors?.required">
                    This field is mandatory.
                </small>
            </p-floatlabel>
            <p-floatlabel class="p-default-form-field p-float-label bottom-border-only created-by-name-container" *ngIf="data.isEditMode || data.isReadOnly">
                <label class="custom-label"> Created By </label>
                <div class="created-by-name">
                  {{ data.experiment.createdByName }}
                </div>
            </p-floatlabel>
        </div>
    </div>
    <div mat-dialog-actions class="experiment-dialog-actions">
        <div class="button-row" *ngIf="!data.isReadOnly">
            <button mat-raised-button color="warn" type="button" (click)="onCancel()"
                [disabled]="isLoading">Cancel</button>
            <button mat-raised-button color="primary" type="submit"
                [disabled]="experimentForm.invalid || isLoading">
                Ok
            </button>
        </div>
        <div class="button-row" *ngIf="data.isReadOnly">
            <button mat-raised-button color="primary" type="button" (click)="onCancel()">Close</button>
        </div>
    </div>
</form>